require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-sass-extend-one-set-of-css-styles-to-another-element.json") })
        }
      }, "path---front-end-libraries-sass-extend-one-set-of-css-styles-to-another-element");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-sass-extend-one-set-of-css-styles-to-another-element!./.cache/json/front-end-libraries-sass-extend-one-set-of-css-styles-to-another-element.json
// module id = 2132
// module chunks = 231608221292675